import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { PhoneVerificationService } from '../../../shared/services/phone-verification/phone-verification.service';
import { ClientStore } from '../../../shared/stores/client/client.store';

/**
 * Guard that blocks unverified users from protected routes and redirects them
 * to the phone verification flow.
 *
 * Assumes clientSetupGuard has already run and a client is available in the store.
 */
export const phoneVerifiedGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const clientStore = inject(ClientStore);
  const phoneVerificationService = inject(PhoneVerificationService);
  const router = inject(Router);

  const client = clientStore.client()!;

  try {
    const status = await firstValueFrom(
      phoneVerificationService.checkPhoneVerificationStatus(client.clientId)
    );

    if (status?.verified) {
      return true;
    }

    return router.parseUrl('/phone-verification/verify-phone');
  } catch (error) {
    console.error('Phone verification check failed', error);
    return router.parseUrl('/error?message=Phone verification failed. Please try again later.');
  }
};
